import { getApiClient } from '@/api/client';
import { getAgreements } from '@/api/generated/endpoints/agreements/agreements';
import { parseResponse } from '@/api/parseResponse';
import { AgreementDetails } from '@/api/schemas';

export type AgreementParty = 'customer' | 'dealer';

export async function getAgreement(
  agreementId: string,
): Promise<AgreementDetails> {
  const response = await getAgreements(getApiClient()).getAgreement(
    agreementId,
  );
  return parseResponse(AgreementDetails, response.data, 'agreement');
}

export async function downloadAgreementDocument(
  agreementId: string,
  party: AgreementParty,
): Promise<Blob> {
  const response = await getAgreements(
    getApiClient(),
  ).downloadAgreementDocument(agreementId, party);
  return response.data;
}
